import Achievements from "./Achievements";
import Hero from "./Hero";
import Info from "./Info";
import Values from "./Values";
import Footer from "../../components/Footer";
import { Box } from "@mui/material";

const AboutUs = () => {
  return (
    <Box>
      <Hero />
      <Info />
      <Values />
      <Achievements />
      <Footer />
    </Box>
  );
};

export default AboutUs;
